import { createContext } from "react";

/**
 * Tracks whether any long-running recording (audio/video/live session) is
 * active in the app. Consumers register/unregister a recording, and the auth
 * layer reads `isRecordingActive` to suspend inactivity-based auto-logout
 * while the user is recording but not physically interacting with the page.
 */
export interface RecordingActivityValue {
    isRecordingActive: boolean;
    setRecordingActive: (active: boolean) => void;
}

export const RecordingActivityContext = createContext<RecordingActivityValue>({
    isRecordingActive: false,
    setRecordingActive: () => { },
});
